// extracted by mini-css-extract-plugin
export default {"tournamentHeading":"style_tournamentHeading__NZXvm"};